module.exports = __webpack_public_path__ + "static/google-shopping-winners-losers-17ff8f45ec481ba27fa87c43254380e1.png";